module.exports = __webpack_public_path__ + "static/sport/game-3.f52e803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/game-3.png
// module id = tkmL
// module chunks = 0